import { render, staticRenderFns } from "./ClientFormModal.vue?vue&type=template&id=2347004c&scoped=true&"
import script from "./ClientFormModal.vue?vue&type=script&lang=js&"
export * from "./ClientFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2347004c",
  null
  
)

export default component.exports